<div class="d-flex align-items-center">
  <span ngClass="{{status}}">{{getDisplayOrderNumber()}}</span>

  <span #milestoneNameContainer class="ml-4 milestone-name text-left" ngClass="text-{{status}}">
    <ng-content></ng-content>
  </span>

  <div class="d-none d-md-flex mx-4" *ngIf="!lastMilestone">
    <img src="../../../../../assets/images/application-status/horizontal-rectangle.svg"/>
  </div>
</div>

<div class="d-flex d-md-none my-2 align-items-start vertical-separator" *ngIf="!lastMilestone">
  <img src="../../../../../assets/images/application-status/vertical-rectangle.svg"/>
</div>
